export const SMALL_SCREEN_MAX = 991;
export const LARGE_SCREEN_MIN = 992;

export default {
  SMALL_SCREEN_MAX,
  LARGE_SCREEN_MIN,
};
